//internal-deps
import { None, Option, Some } from "@swiggy-private/js-fp";

export const { whichTransitionEndEvent } = new (class {
    private _transitionEndEvent: Option<string> = None;
    public whichTransitionEndEvent = (el?: HTMLElement): string | undefined => {
        if (this._transitionEndEvent.isSome()) {
            return this._transitionEndEvent.unwrap();
        }

        // check if document is defined
        if (typeof document === "undefined") {
            return;
        }

        let t: string;
        const transitions: { [key: string]: string } = {
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
        };

        el = el === undefined ? document.createElement("fakeelement") : el;

        for (t in transitions) {
            // eslint-disable-next-line no-prototype-builtins
            if (transitions.hasOwnProperty(t) && el.style[t as keyof CSSStyleDeclaration] !== undefined) {
                this._transitionEndEvent = Some(transitions[t]);
                return this._transitionEndEvent.unwrapOr("transitionend");
            }
        }
    };
})();
